// accounts/vm-form
import { useLoadingAction } from 'src/hooks/use-actions';
import { apiCreate, apiUpdate, getStatusMapper, apiDetele, 
  apiBlockAccount, apiUnlockAccount, apiChangeInfors, apiChangeNote } from './data-form';

const useForms = () => {
  const insertAccount = (payload, onSuccess, onError) =>
      useLoadingAction(apiCreate, payload, onSuccess, onError);
  
  const updateAccount = (payload, onSuccess, onError) =>
    useLoadingAction(apiUpdate, payload, onSuccess, onError);

  const deleteAccount = (payload, onSuccess, onError) =>
    useLoadingAction(apiDetele, payload, (result) => {onSuccess(getStatusMapper(result)); }, onError);

  const blockAccount = (payload, onSuccess, onError) =>
    useLoadingAction(apiBlockAccount, payload, (result) => {onSuccess(getStatusMapper(result)); }, onError);

  const unlockAccount = (payload, onSuccess, onError) =>
    useLoadingAction(apiUnlockAccount, payload, (result) => {onSuccess(getStatusMapper(result)); }, onError);

  const changeAccountNote = (payload, onSuccess, onError) =>
    useLoadingAction(apiChangeNote, payload, onSuccess, onError);

  return {
    insertAccount,
    updateAccount,
    deleteAccount,
    blockAccount,
    unlockAccount,
    changeAccountNote,
  };
};

export default useForms;
